export default {"src":"/_next/static/media/file-modul-ajar.eb29ef3f.svg","height":18,"width":14};